import  React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import yn from 'yn'

import getCurrencySymbol from '../../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../../utilities/currency/formatPrice'

class BkFlowRoomCardActiveDestinationFee extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			activeCurrencyData,
			cards,
			configData,
			currentRateCode,
			hotelLabels,
			loyaltyRatesData,
			roomTypeData,
			urlData
		} = this.props
		let activeHotelCode = null
		let matchedProperty = null
		let propertyClassType = 20

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (matchedProperty && matchedProperty.propertyClassType) {
				propertyClassType = Number(matchedProperty.propertyClassType)
			}
		}

		const roomRates = _.get(roomTypeData, 'viewExtensions.roomRates', [])

		let currentRoomRate = roomRates.find(roomRate => {
			return roomRate.ratePlanCode === currentRateCode
		})

		const roomTypeCode = _.get(cards, 'roomTypeCode', null)
		const loyaltyRoomTypes = _.get(loyaltyRatesData, `${currentRateCode}.roomTypes`, [])
		const loyaltyRoomType = loyaltyRoomTypes.find(roomType => {
			return roomType.roomTypeCode === roomTypeCode
		})
		const loyaltyRoomRates = _.get(loyaltyRoomType, 'viewExtensions.roomRates', [])

		if (!_.isEmpty(loyaltyRoomRates)) {
			currentRoomRate = loyaltyRoomRates.find(roomRate => {
				return roomRate.ratePlanCode === currentRateCode
			})
		}

		const roomRateTaxes = _.get(currentRoomRate, 'rates[0].total.taxes.tax', [])
		const roomRateDestinationFeeCode = _.get(currentRoomRate, 'viewExtensions.resortDestinationFeeCode', null)
		const roomRateDestinationFee = roomRateTaxes.find(tax => {
			return Number(tax.code) === Number(roomRateDestinationFeeCode)
		})
		const destinationFeeAmount = _.get(roomRateDestinationFee, 'amount', null)

		let rateCurrencyCode = _.get(currentRoomRate, 'rates[0].total.currencyCode', 'USD')
		let rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode)

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			rateCurrencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				rateCurrencySymbol = activeCurrencyData.currencySymbol
			} else {
				rateCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}

		return destinationFeeAmount ? (
			<div className="bk-flow-room__active-destination-fee">
				<p className="bk-flow-room__active-destination-fee-copy">
					{hotelLabels.allRatesPriceFrequencyMessage ? hotelLabels.allRatesPriceFrequencyMessage : 'All Rates Average/Night'}
				</p>

				<p className="bk-flow-room__active-destination-fee-price">
					<span className="icon">+ </span>
					<span className="currency-symbol">{ rateCurrencySymbol }</span>
					<span className="price">{ formatPrice(destinationFeeAmount, 0) }</span>
					<span className="currency-code"> { rateCurrencyCode } </span>
					<span className="label">
						{ propertyClassType === 30 ?
							hotelLabels.resortFee ? hotelLabels.resortFee : 'Resort Fee'
						: propertyClassType === 47 ?
							hotelLabels.amenityFee ? hotelLabels.amenityFee : 'Amenity Fee'
						: propertyClassType === 26 ?
							hotelLabels.sustainabilityFee ? hotelLabels.sustainabilityFee : 'Sustainability Fee'
						:
							hotelLabels.destinationFee ? hotelLabels.destinationFee : 'Destination Fee'
						}
						{process.env.REACT_APP_COMPONENT_PRICE_NIGHT_LABELS && `/${hotelLabels ? hotelLabels.night : 'Night'}`}
					</span>
				</p>
			</div> ) : ( null
		)
	}
}

function mapStateToProps(state) {
	return {
		loyaltyRatesData: state.loyaltyRatesData.availability,
		activeCurrencyData: state.activeCurrencyData,
	}
}
export default connect(mapStateToProps, null)(BkFlowRoomCardActiveDestinationFee)



// WEBPACK FOOTER //
// ./src/components/room/elements/default/configured/BkFlowRoomCardActiveDestinationFee.js